import { PackageCheck, Undo2, Trash2, Truck, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

const STEPS = {
  pressing_returned_at: { label: "Rendu par le pressing", done: "Revenu du pressing le", icon: Truck, btn: "bg-white hover:bg-slate-50 text-slate-700 border border-slate-300", badge: "text-slate-600 bg-white border border-slate-300", pending: "Chez le pressing", pendingCls: "text-slate-600 bg-white border border-slate-300", slug: "pressing" },
  returned_at: { label: "Rendu au client", done: "Rendu au client le", icon: PackageCheck, btn: "bg-white hover:bg-slate-50 text-slate-700 border border-slate-300", badge: "text-slate-600 bg-white border border-slate-300", pending: "Non rendu au client", pendingCls: "text-slate-600 bg-white border border-slate-300", slug: "client" },
};

const StepControl = ({ deposit, field, onToggle }) => {
  const s = STEPS[field];
  const Icon = s.icon;
  const tid = `${s.slug}-${deposit.id}`;
  const ready = field === "pressing_returned_at" && !deposit.returned_at;
  if (deposit[field]) {
    return (
      <div className="flex items-center gap-1">
        <span className={`text-xs font-semibold px-2 py-1 rounded-full ${ready ? "text-white bg-emerald-600" : s.badge}`} data-testid={`deposit-${tid}-badge`}>
          {s.done} {new Date(deposit[field]).toLocaleDateString("fr-FR")}
        </span>
        {onToggle && (
          <Button variant="ghost" size="icon" className="h-7 w-7" title="Annuler" onClick={() => onToggle(deposit, field)} data-testid={`deposit-${tid}-undo-btn`}><Undo2 className="w-3.5 h-3.5" /></Button>
        )}
      </div>
    );
  }
  if (!onToggle) return <span className={`text-xs font-semibold px-2 py-1 rounded-full ${s.pendingCls}`} data-testid={`deposit-${tid}-pending`}>{s.pending}</span>;
  return (
    <Button size="sm" className={`h-8 ${s.btn}`} onClick={() => onToggle(deposit, field)} data-testid={`deposit-${tid}-btn`}>
      <Icon className="w-4 h-4 mr-1" />{s.label}
    </Button>
  );
};

export const DepositHistoryList = ({ deposits, onToggle, onDelete, onPrint }) => (
  <div className="space-y-2" data-testid="concierge-deposit-history">
    {deposits.map((d) => (
      <div key={d.id} className={`border rounded-lg p-3 text-sm ${d.pressing_returned_at && !d.returned_at ? "bg-emerald-50 border-emerald-400" : "bg-white"}`} data-testid={`concierge-deposit-${d.id}`}>
        <div className="flex justify-between font-semibold">
          <span>{d.number}</span>
          <span className="text-pink-600">{d.total.toFixed(2)} €</span>
        </div>
        <p className="text-xs text-slate-500">
          {new Date(d.created_at).toLocaleString("fr-FR")}{d.tracking_number ? ` — Marquage : ${d.tracking_number}` : ""}
          {d.credit_used ? ` — Avoir : -${d.credit_used.toFixed(2)} €` : ""}
        </p>
        <p className="text-xs mt-1">{d.items.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
        <div className="flex items-center justify-end gap-2 mt-2 flex-wrap">
          <StepControl deposit={d} field="pressing_returned_at" onToggle={onToggle} />
          <StepControl deposit={d} field="returned_at" onToggle={onToggle} />
          {onPrint && (
            <Button variant="outline" size="sm" className="h-8" onClick={() => onPrint(d)} data-testid={`deposit-print-btn-${d.id}`}><Printer className="w-4 h-4 mr-1" />Imprimer</Button>
          )}
          {onDelete && (
            <Button variant="ghost" size="icon" className="h-8 w-8 text-red-500" title="Supprimer le bon" onClick={() => onDelete(d)} data-testid={`deposit-delete-btn-${d.id}`}><Trash2 className="w-4 h-4" /></Button>
          )}
        </div>
      </div>
    ))}
    {deposits.length === 0 && <p className="text-center text-slate-400 py-4">Aucun bon de dépôt</p>}
  </div>
);
